import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useService from "../../Hooks/useService";
import PrimarySidebarLayout from "../../Layout/PrimarySidebarLayout";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import FAIcon from "../../UI/FAIcon/FAIcon";
import PlansSidebar from "./PlansSidebar";
import AcademicPlanService from "../../../Services/AcademicPlan.service";
import PlansSearch from "./PlansSearch";
import { AcademicPlanStatusIDs } from "../../../Domain/AcademicPlanStatus/AcademicPlanStatus.model";
import SEO from "../../UI/SEO/SEO";
const PAGE_SIZE = 25;
const PlansIndex = (props) => {
    var _a, _b, _c, _d, _e;
    const [planStatusSummary, getPlanStatusSummary] = useService(AcademicPlanService.getPlanStatusSummary);
    const [plansState, getPlans] = useService(AcademicPlanService.search);
    const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const defaultAcademicPlanStatusId = params.get("academicPlanStatusId");
    let initialAcademicPlanStatusId = AcademicPlanStatusIDs.PENDING_ADVISOR;
    if (defaultAcademicPlanStatusId) {
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"24481091-b473-4b2f-8193-c245901eea82"'.
        initialAcademicPlanStatusId = defaultAcademicPlanStatusId;
    }
    // By default, load the plans that are in the pending advisor status
    const [criteria, setCriteria] = React.useState({
        academicPlanStatusIds: [initialAcademicPlanStatusId],
    });
    const counts = {
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        requiresAdvisorFeedback: ((_a = planStatusSummary.data) === null || _a === void 0 ? void 0 : _a.pendingAdvisorCount) || 0,
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        awaitingStudentResponse: ((_b = planStatusSummary.data) === null || _b === void 0 ? void 0 : _b.pendingStudentCount) || 0,
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        approved: ((_c = planStatusSummary.data) === null || _c === void 0 ? void 0 : _c.approvedCount) || 0,
    };
    useEffect(() => {
        // Load the information for the counts in the sidebar.
        getPlanStatusSummary();
    }, [getPlanStatusSummary]);
    const onSearch = (searchCriteria) => {
        // @ts-expect-error - TS2345 - Argument of type '{ search: string; academicPlanStatusIds: string[]; isOffPlan: boolean; max: number; offset: number; }' is not assignable to parameter of type 'SetStateAction<{ academicPlanStatusIds: "24481091-b473-4b2f-8193-c245901eea82"[]; }>'.
        setCriteria(Object.assign(Object.assign({}, criteria), searchCriteria));
    };
    const loadPlans = React.useCallback(() => {
        // @ts-expect-error - TS2345 - Argument of type '{ academicPlanStatusIds: "24481091-b473-4b2f-8193-c245901eea82"[]; max: number; offset: number; }' is not assignable to parameter of type 'AcademicPlanSearch'.
        getPlans(Object.assign({ max: PAGE_SIZE, offset: currentPageIndex * PAGE_SIZE }, criteria));
    }, [getPlans, criteria, currentPageIndex]);
    React.useEffect(() => {
        loadPlans();
    }, [loadPlans]);
    return (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Plans" }), _jsx(PrimarySidebarLayout, { sidebar: (setIsOpen) => (_jsx(PlansSidebar
                // @ts-expect-error - TS2322 - Type '(arg1?: boolean | null | undefined) => void' is not assignable to type '() => Record<any, any>'.
                , { 
                    // @ts-expect-error - TS2322 - Type '(arg1?: boolean | null | undefined) => void' is not assignable to type '() => Record<any, any>'.
                    setIsOpen: setIsOpen, counts: {
                        requiresAdvisorFeedback: counts.requiresAdvisorFeedback,
                        awaitingStudentResponse: counts.awaitingStudentResponse,
                        approved: counts.approved,
                        // @ts-expect-error - TS2339 - Property 'offPlan' does not exist on type '{ readonly requiresAdvisorFeedback: any; readonly awaitingStudentResponse: any; readonly approved: any; }'.
                        offPlan: counts.offPlan,
                    }, 
                    // @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'Record<any, any>'.
                    onSearch: (searchCriteria) => onSearch(searchCriteria), defaultAcademicPlanStatusId: initialAcademicPlanStatusId, 
                    // @ts-expect-error - TS2739 - Type '{ academicPlanStatusIds: "24481091-b473-4b2f-8193-c245901eea82"[]; }' is missing the following properties from type 'AcademicPlanSearch': search, isOffPlan, max, offset
                    criteria: criteria })), children: _jsx(SecondaryNavLayout, { nav: _jsxs("button", { type: "button", className: "btn btn-link", onClick: () => {
                            loadPlans();
                        }, children: [_jsx(FAIcon, { icon: "sync", addMarginRight: true }), "Refresh"] }), children: _jsx(PlansSearch, { onSearch: onSearch, 
                        // @ts-expect-error - TS2322 - Type 'AcademicPlanDto[] | undefined' is not assignable to type 'AcademicPlanDto[]'.
                        plans: (_d = plansState === null || plansState === void 0 ? void 0 : plansState.data) === null || _d === void 0 ? void 0 : _d.data, 
                        // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
                        totalPlanCount: (_e = plansState === null || plansState === void 0 ? void 0 : plansState.data) === null || _e === void 0 ? void 0 : _e.total, isLoading: plansState.isLoading, currentPageIndex: currentPageIndex, setCurrentPageIndex: (pageIndex) => {
                            setCurrentPageIndex(pageIndex);
                        }, pageSize: PAGE_SIZE, 
                        // @ts-expect-error - TS2322 - Type '{ academicPlanStatusIds: "24481091-b473-4b2f-8193-c245901eea82"[]; }' is not assignable to type 'AcademicPlanSearch'.
                        criteria: criteria }) }) })] }));
};
export default PlansIndex;
